export default {
    titulo: "Fallas",
    nueva: "Nueva falla",
    reparada: "Falla reparada",
    pregReparada: "¿Confirmas que se reparó la falla?",
    msgDuplicada: "Falla duplicada",
    ok: "Bien",
    mal: "Mal",
    obs: "Observaciones (click para editar)",
    eliminar: "Eliminar falla",
    pregEliminar: "¿Confirmas que deseas eliminar la falla?",
    editar: "Editar falla"
}